import { render } from "./ManageFeatures.vue?vue&type=template&id=8e3dd876"
import script from "./ManageFeatures.vue?vue&type=script&lang=js"
export * from "./ManageFeatures.vue?vue&type=script&lang=js"

import "./ManageFeatures.vue?vue&type=style&index=0&id=8e3dd876&lang=css"

import exportComponent from "E:\\trackzone\\Admin_panel\\admin panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__